"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigate = exports.NavigateSetter = void 0;
const react_router_1 = require("react-router");
// eslint-disable-next-line no-console,import/no-mutable-exports
let navigate = () => console.warn('Attempted history nav before init!');
exports.navigate = navigate;
function NavigateSetter({ children }) {
    exports.navigate = navigate = (0, react_router_1.useNavigate)();
    return children;
}
exports.NavigateSetter = NavigateSetter;
exports.default = NavigateSetter;
